import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { useFilterTracking } from "../hooks/useFilterTracking";
import { toStringArray } from "../utils/buildQueryString";
import ImageCheckboxGrid from "./ImageCheckboxGrid";
import React, { useState } from "react";
export default function FeaturedCheckboxList({ filter, facet, }) {
    var _a, _b, _c, _d;
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const { trackFilterChange } = useFilterTracking();
    const [search, setSearch] = useState("");
    const param = filter.id;
    const current = toStringArray(selectedState[param]);
    const allItems = Object.values((_a = facet === null || facet === void 0 ? void 0 : facet.facet_data) !== null && _a !== void 0 ? _a : {});
    const featuredSlugs = new Set((_c = (_b = filter.featuredItems) === null || _b === void 0 ? void 0 : _b.slugs) !== null && _c !== void 0 ? _c : []);
    const matchesSearch = (item) => !search || item.label.toLowerCase().includes(search.toLowerCase());
    const featuredList = allItems.filter((item) => featuredSlugs.has(item.value) && matchesSearch(item));
    const filteredList = allItems.filter(matchesSearch);
    function handleToggle(value) {
        const arr = toStringArray(selectedState[param]);
        const next = arr.includes(value)
            ? arr.filter((v) => v !== value)
            : [...arr, value];
        trackFilterChange(filter, next);
        dispatch({
            type: "set_selected",
            payload: Object.assign(Object.assign({}, selectedState), { [param]: next.length ? next : undefined }),
        });
    }
    const hasSearch = (_d = filter.plugins) === null || _d === void 0 ? void 0 : _d.includes("search");
    return (<div className="space-y-6">
      {hasSearch && (<div className="flex items-center rounded-full bg-[#EBECEF] border border-[#020309]">
          <input type="text" placeholder="Szukaj…" value={search} onChange={(e) => setSearch(e.target.value)} className="flex-1 bg-transparent border-none focus:ring-0 p-0 h-[43px] pl-5 pr-1 text-[#66676C]"/>
          {search ? (<button type="button" aria-label="Wyczyść pole wyszukiwania" className="w-10 h-10 flex items-center justify-center mr-2.5" onClick={() => setSearch("")}>
              <svg className="size-5" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10 0C4.477 0 0 4.477 0 10C0 15.522 4.477 20 10 20C15.523 20 20 15.522 20 10C20 4.477 15.523 0 10 0ZM10.0118 8.65766L7.43078 6.07666H6.01678V7.49066L8.59778 10.0717L6.01678 12.6527V14.0667H7.43078L10.0118 11.4857L12.5928 14.0667H14.0068V12.6527L11.4258 10.0717L14.0068 7.49066V6.07666H12.5928L10.0118 8.65766Z" fill="currentColor"/>
              </svg>
            </button>) : (<span className="w-10 h-10 flex items-center justify-center mr-2.5">
              <svg className="size-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.5 17C6.916 17 4 14.084 4 10.5C4 6.916 6.916 4 10.5 4C14.084 4 17 6.916 17 10.5C17 14.084 14.084 17 10.5 17ZM17.1685 15.7545C18.3115 14.3065 19 12.484 19 10.5C19 5.813 15.187 2 10.5 2C5.813 2 2 5.813 2 10.5C2 15.187 5.813 19 10.5 19C12.4835 19 14.3065 18.3115 15.754 17.1685L20.5855 22H22V20.586L17.1685 15.7545Z" fill="currentColor"/>
              </svg>
            </span>)}
        </div>)}

      {featuredList.length > 0 && (<div className="space-y-4">
          <p className="text-sm font-semibold text-gray-900">
            {filter.featuredItems.label}
          </p>
          <ImageCheckboxGrid items={featuredList} current={current} onToggle={handleToggle}/>
        </div>)}

      <div className="space-y-4">
        <p className="text-sm font-semibold text-gray-900">Wszystkie</p>
        <div className="space-y-2">
          {filteredList.length === 0 ? (<p className="text-sm text-gray-500 py-2">
              Brak wyników dla &ldquo;{search}&rdquo;
            </p>) : (<div>
              {filteredList.map((item) => (<label key={item.value} className={`flex items-center gap-3 py-2 cursor-pointer ${item.disabled || !item.available
                    ? "opacity-50 pointer-events-none"
                    : ""}`}>
                  <input type="checkbox" checked={current.includes(item.value)} onChange={() => handleToggle(item.value)} disabled={item.disabled || !item.available} className="rounded border-[#0C191D] size-[18px] rounded-[3px] text-black focus:ring-0 focus:ring-offset-0"/>
                  <span className="text-gray-900">{item.label}</span>
                </label>))}
            </div>)}
        </div>
      </div>
    </div>);
}
